var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSketch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 -12 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDB300",
    d: "m127.9998.0002-72.145 7.628-55.855 74.979 128 149.055 128-149.055-55.854-74.979z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB6C00",
    d: "m0 82.6076 128 149.054-76.154-149.054zM204.1533 82.6076l-76.153 149.054 127.999-149.054z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDAD00",
    d: "m51.8463 82.6076 76.154 149.054 76.154-149.054z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDD231",
    d: "m55.8548 7.6282-4.009 74.979 76.154-82.607zM204.1533 82.6076l-4.008-74.98-72.145-7.627z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDAD00",
    d: "M204.1542 82.6076h51.845l-55.854-74.98zM0 82.6076h51.846l4.009-74.98z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEEEB7",
    d: "m127.9998.0002-76.154 82.607h152.308z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketch);
export default __webpack_public_path__ + "static/media/sketch.70640b124517a4b3532b57500eb4a5ca.svg";
export { ForwardRef as ReactComponent };